import AddEditSection from "../../../components/AddEditSection";
import Breadcrumb from "../../../parts/Breadcrumb";
import React, {useState, useEffect} from "react";
import labels from "../../../constants/MobilityOption";
import configuration from '../../../config';
import { toast } from 'react-toastify';
import {each} from 'underscore';

// For Add Role
function Add({history}) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
  ];
  const typeOpt = [
    { id: 1, title: "Vehicle", value: "vehicle" },
    { id: 2, title: "Other", value: "other" },
  ];
  const [languages, setLanguages] = useState([])
  const [icon, setIcon] = useState(null);
  const [fieldArr, setFieldArr] = useState([  
    { id: 1, title: "Image or Icon ", name: "icon", type: "FileInput" },
    {
      id: 2,
      title: "Type",
      name: "type",
      type: "Dropdown",
      options: typeOpt,
    },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },     
  ]);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    status: "",
  });
  useEffect(() => {
    configuration.getAPI({ url: 'language/list', params: { status: 'active' } }).then((data1) => {
      if (data1.status === 200) {
        setLanguages(data1.payload)
        let titleArr = [];
        let descArr = [];
        data1.payload.map((language, index) => {
          titleArr.push({
            id: 3 + index,
            title: `Title [${language.title}]`,
            name: `title_${language.code}`,
            type: "TextInput"
          });
          descArr.push({
            id: 3 + index,
            title: `Description [${language.title}]`,
            name: `caption_${language.code}`,
            type: "TextArea"
          });
        })
        // const fullCoulnmArr = fieldArr.concat(titleArr, descArr);
        // setFieldArr(fullCoulnmArr)
        setFieldArr([...titleArr, ...descArr, ...fieldArr])
      }
    }).catch(error => {
      return toast.error(error.message)
    });
  }, []);
  function handleValidation() {
    let flag = true;
    let error = {}
    each(languages, (lang, ind) => {
      if (!fields['title_' + lang.code]) {
        error['title_' + lang.code] = "Please enter title in " + lang.title
        flag = false
      }
      if (!fields['caption_' + lang.code]) {
        error['caption_' + lang.code] = "Please enter description in " + lang.title
        flag = false
      }
    })

    if (!fields.icon) {
      error['icon'] = "Please select icon"
      flag = false
    }
    
    if (!fields.status) {
      error['status'] = "Please select status"
      flag = false
    }
    setErrors({ ...error })
    return flag;
  }
  const handleSubmit = () =>{
    if (handleValidation()) {
      const formData = new FormData();
      formData.append('icon', icon);
      formData.append('fields', JSON.stringify({...fields, lang_code:'EN'}));
      configuration.postFormDataAPI({url:'mobility-option/create', params:formData}).then((data) => {
        if(data.status === 200){
          history.push('/mobilityoption')
        } else if (data.status === 404) {
          return toast.error(data.error.message)
        } else {
          return toast.error('Something went wrong')
        }
      }).catch(error => {
        return toast.error(error.message)
      });
    }
}

function cancleImage(field, e) {
  setIcon(null);
  setFields({ ...fields, [field]: '' })
}

function handleChange(field, e) {
  if(field === 'icon'){
      setIcon(e.target.files[0]);
      setFields({ ...fields, [field]: URL.createObjectURL(e.target.files[0])})
    } else {
      setFields({ ...fields, [field]: e.target.value })
    }
}
  return (
    <>
      <Breadcrumb module={labels.AddMobilityOption} />
      <AddEditSection title="Add  Mobility Option" path="/mobilityoption" fields={fieldArr} fieldValue={fields} fieldError={errors} handleChange={handleChange} cancleImage={cancleImage} handleSubmit={handleSubmit} />
    </>
  );
}

export default Add;
